module.exports = __webpack_public_path__ + "img/default_avatar.83d6e9d8.png";